import React from "react"
import cn from "classnames"

export interface LabelProps {
  children?: React.ReactNode
  id?: string
  className?: string
  skeleton?: boolean
}

const Label: React.FC<LabelProps> = ({ children, id, className, skeleton }) => {
  return (
    <label htmlFor={id} className={cn("paragraph-xs bold mb-0 block", { skeleton }, className)}>
      {children}
    </label>
  )
}

export default Label
